module.exports = __webpack_public_path__ + "img/heritage.abd53234.svg";